/**
 * Standard debounce delay for search/filter inputs (250ms).
 * Use for text inputs that trigger API calls or filter operations.
 */
export const SEARCH_DEBOUNCE_MS = 250;
